<template>
    <div class="radio-select-score">
        <div class="title" v-html="title"></div>
        <div class="score">
            <div class="tip">总分</div>
            <div class="score-val">{{ value }}分</div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'RadioSelectScore',
        props: {
            value:[String,Number],
            scoreKeys: {
                type: Array,
                default:function () {
                    return []
                }
            },
            title: {
                type: String,
                default:''
            },
        },
        mounted() {

            let selectAttrKey = this.scoreKeys.map(r=>{
                return '[data-key="' + r +'"]'
            });

            setTimeout(_=>{
                let scoreDom = document.querySelectorAll(selectAttrKey.join(','));
                let scoreDomOption = [];
                scoreDom.forEach(item=>{
                    scoreDomOption.push(...item.querySelectorAll('.select-option'))
                });

                scoreDomOption.forEach(option=>{
                    option.onclick = _=>{
                        let score = 0;
                        this.$nextTick(_=>{
                            scoreDom.forEach(r=>{
                                score += parseInt(r.getAttribute('data-val') || 0)
                            });
                            this.$emit('input',score)
                        });
                    }
                })
            },600)
        }
    }
</script>
<style lang="scss" scoped>
    .radio-select-score{
        padding: 16px;
        width: 100%;
        .title{
            color: #26292F;
            font-size: 16px;
        }
        .score{
            width: 100%;
            margin-top: 16px;
            padding:13px 0 13px 16px;
            display: flex;
            align-items: center;
            border: 1px solid #D6D3D3;
            overflow: hidden;
            .tip{
                flex: 1;
            }
            .score-val{
                color: #FFA307;
                font-size: 16px;
                height: 17px;
                border-left: 1px solid #D6D3D3;
                padding: 0 16px;
            }

        }

    }
</style>
